// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Les paliers de la grille self-service, et la distinction qui compte.
//
// Grille du 05/09/2026 (révision Alembic 0013) : Essentiel / Pro / Cabinet.
// PRO_PLUS n'a pas été SUPPRIMÉ mais DÉSACTIVÉ — des comptes y sont peut-être
// encore rattachés, et des analyses passées y sont imputées.
//
// ⚠️ D'où DEUX listes, et non une :
//
//   PALIERS_VENDABLES  → ce qu'on peut ASSIGNER à un compte aujourd'hui.
//                        PRO_PLUS en est absent : le proposer rattacherait un
//                        client à un forfait qui n'est plus commercialisé.
//
//   PALIERS_HISTORIQUE → ce sur quoi on peut FILTRER (statistiques, facturation).
//                        PRO_PLUS y reste : l'en retirer rendrait invisible
//                        l'historique des comptes qui y sont passés — une perte
//                        silencieuse, exactement le genre que personne ne voit.
//
// `LIBELLE_PALIER` porte le nom commercial. `pricing_tiers.nom_affiche` dit la
// même chose en base, mais aucune route ne l'expose au frontend.

export const LIBELLE_PALIER = {
  ESSENTIEL: 'Essentiel',
  PRO:       'Pro',
  CABINET:   'Cabinet',
  PRO_PLUS:  'PRO+ (retiré)',
};

export const PALIERS_VENDABLES = ['ESSENTIEL', 'PRO', 'CABINET'];

export const PALIERS_HISTORIQUE = [...PALIERS_VENDABLES, 'PRO_PLUS'];

export const libellePalier = (code) => LIBELLE_PALIER[code] || code || '—';
